import { BaseEdge, getBezierPath } from '@xyflow/react';
import { useContext, useMemo } from 'react';
import WorkflowContext from '../../Workflow/WorkflowContext';
import SelfConnectingEdge from './SelfConnectingEdge';

const BezierEdge = props => {
  const {
    id, sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
    pathOptions, source, target,
    label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius,
    interactionWidth, className, markerStart,
  } = props;

  const { state } = useContext(WorkflowContext);

  const stroke = useMemo(() => {
    return state?.steps?.[target]?.color || 'gray';
  }, [state, target]);

  if (target === source) {
    return <SelfConnectingEdge {...props} />;
  }

  const [path, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    curvature: pathOptions?.curvature,
  });

  return (
    <>
      <svg style={{ position: 'absolute', top: 0, left: 0 }}>
        <defs>
          <marker id={`edge-marker-${id}`} viewBox="-10 -10 20 20" markerHeight={20} markerWidth={20} refX={0} refY={0}>
            <polyline stroke={stroke} fill={stroke} strokeWidth={1} strokeLinecap="round" strokeLinejoin="round" points="-5,-4 0,0 -5,4 -5,-4" />
          </marker>
        </defs>
      </svg>
      <BaseEdge
        id={id}
        path={path}
        labelX={labelX}
        labelY={labelY}
        label={label}
        labelStyle={labelStyle}
        labelShowBg={labelShowBg}
        labelBgStyle={labelBgStyle}
        labelBgPadding={labelBgPadding}
        labelBgBorderRadius={labelBgBorderRadius}
        interactionWidth={interactionWidth}
        className={className}
        markerStart={markerStart}
        style={{ stroke }}
        markerEnd={`url(#edge-marker-${id})`}
      />
    </>
  );
};

export default BezierEdge;
